/* istanbul ignore file */
import React from 'react';

import { agentStudioEnabledSelector } from '@lumapps/agent-hub/ducks/selectors';
import { canViewInstanceAnalytics, canViewPlatformAnalytics } from '@lumapps/analytics/ducks/selectors';
import { isAskAIEnabled } from '@lumapps/ask-ai/ducks/selectors';
import { canAccessBroadcast } from '@lumapps/broadcasts/ducks/selectors';
import { isLearningEnabled } from '@lumapps/learning/ducks/selectors';
import { permissionsSelector } from '@lumapps/permissions';
import { useSelector } from '@lumapps/redux/react';
import { canViewSearchAnalytics } from '@lumapps/search-analytics/ducks/selectors';

import { AnalyticsSideNavigation as UI, AnalyticsSideNavigationProps } from './AnalyticsSideNavigation';

export const AnalyticsSideNavigation: React.FC<Pick<AnalyticsSideNavigationProps, 'id'>> = (props) => {
    const hasSearchAnalyticsAccess = useSelector(canViewSearchAnalytics);
    const canViewPlatformEntry = useSelector(canViewPlatformAnalytics);
    const canViewInstanceEntry = useSelector(canViewInstanceAnalytics);
    const isFFAskAiEnabled = useSelector(isAskAIEnabled);
    const isAgentStudioEnabled = useSelector(agentStudioEnabledSelector);
    const permissions = useSelector(permissionsSelector);
    const learningEnabled = useSelector(isLearningEnabled);
    const hasBroadcastFF = useSelector(canAccessBroadcast);
    const hasBroadcastAccess = hasBroadcastFF && canViewPlatformEntry;
    const hasSiteAnalyticsAccess = canViewInstanceEntry;
    const hasExtendedAnalyticsAccess = canViewPlatformEntry;
    const hasMobileAnalyticsAccess = canViewPlatformEntry;
    const hasAgentsAnalyticsAccess = canViewPlatformEntry && isAgentStudioEnabled;
    const hasAskAiAccess = canViewPlatformEntry && isFFAskAiEnabled;
    const { canReadLearningAnalytics } = permissions.authorizations;
    const hasLearningAnalyticsAccess = canReadLearningAnalytics && learningEnabled;

    return (
        <UI
            {...props}
            hasSearchAnalyticsAccess={hasSearchAnalyticsAccess}
            hasSiteAnalyticsAccess={hasSiteAnalyticsAccess}
            hasExtendedAnalyticsAccess={hasExtendedAnalyticsAccess}
            hasMobileAnalyticsAccess={hasMobileAnalyticsAccess}
            hasLearningAnalyticsAccess={hasLearningAnalyticsAccess}
            hasAgentsAnalyticsAccess={hasAgentsAnalyticsAccess}
            hasAskAiAccess={hasAskAiAccess}
            hasBroadcastAccess={hasBroadcastAccess}
        />
    );
};
